// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  var $parcel$bundleURL;function $parcel$resolve(url) {  url = importMap[url] || url;  if (!$parcel$bundleURL) {    try {      throw new Error();    } catch (err) {      var matches = ('' + err.stack).match(        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,      );      if (matches) {        $parcel$bundleURL = matches[0];      } else {        return distDir + url;      }    }  }  return new URL(distDir + url, $parcel$bundleURL).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"axXgE":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "eQCjh": "splide.97f1e563.js"
});

},{}],"lqvwy":[function(require,module,exports,__globalThis) {
require("7fe80a3a61d1c5c5").then(function(param) {
    var _loop = function(i) {
        var updateArrowStates = function updateArrowStates() {
            if (!prevBtn || !nextBtn) return;
            var end = splide.Components.Controller.getEnd();
            prevBtn.setAttribute("aria-disabled", splide.index === 0 ? "true" : "false");
            nextBtn.setAttribute("aria-disabled", splide.index >= end ? "true" : "false");
        };
        var trackEl = sliders[i].querySelector(".splide__track");
        var trackId = "splide-track-" + i;
        if (trackEl) trackEl.setAttribute("id", trackId);
        var splide = new Splide(sliders[i], {
            type: "slide",
            arrows: false,
            pagination: false,
            padding: "5rem",
            gap: "1.5rem",
            perPage: 3,
            breakpoints: {
                1280: {
                    perPage: 3,
                    padding: "2rem"
                },
                992: {
                    perPage: 2,
                    padding: "1.25rem"
                },
                767: {
                    perPage: 1,
                    padding: "1.25rem"
                }
            }
        }).mount();
        var container = document.querySelector(".arrow_container");
        var prevBtn = container && container.querySelector(".splide__arrow--prev");
        var nextBtn = container && container.querySelector(".splide__arrow--next");
        if (prevBtn) {
            prevBtn.setAttribute("aria-controls", trackId);
            prevBtn.addEventListener("click", function() {
                return splide.go("<");
            });
        }
        if (nextBtn) {
            nextBtn.setAttribute("aria-controls", trackId);
            nextBtn.addEventListener("click", function() {
                return splide.go(">");
            });
        }
        updateArrowStates();
        splide.on("moved", updateArrowStates);
    };
    var Splide = param.Splide;
    var sliders = document.querySelectorAll(".content-single-practice__photos .splide");
    for(var i = 0; i < sliders.length; i++)_loop(i);
    initLightbox();
}).catch(function(err) {
    console.error(err);
});
function initLightbox() {
    var lightbox = document.getElementById("practice-lightbox");
    if (!lightbox) return;
    var lightboxImg = lightbox.querySelector(".practice-lightbox__img");
    var lightboxClose = lightbox.querySelector(".practice-lightbox__close");
    var lightboxPrev = lightbox.querySelector(".practice-lightbox__prev");
    var lightboxNext = lightbox.querySelector(".practice-lightbox__next");
    var lightboxBackdrop = lightbox.querySelector(".practice-lightbox__backdrop");
    var lightboxCounter = lightbox.querySelector(".practice-lightbox__counter");
    // Gather images from all slides (skip Splide clones if any)
    var slides = Array.from(document.querySelectorAll(".content-single-practice__photos .splide__slide[data-lightbox-src]")).filter(function(slide) {
        return !slide.classList.contains("splide__slide--clone");
    });
    var images = slides.map(function(slide) {
        return {
            src: slide.dataset.lightboxSrc,
            alt: slide.dataset.lightboxAlt || ""
        };
    });
    var currentIndex = 0;
    var previouslyFocused = null;
    function updateImage() {
        if (!lightboxImg || !images[currentIndex]) return;
        lightboxImg.src = images[currentIndex].src;
        lightboxImg.alt = images[currentIndex].alt;
        if (lightboxPrev) lightboxPrev.setAttribute("aria-disabled", currentIndex === 0 ? "true" : "false");
        if (lightboxNext) lightboxNext.setAttribute("aria-disabled", currentIndex >= images.length - 1 ? "true" : "false");
        if (lightboxCounter && images.length > 1) lightboxCounter.textContent = "".concat(currentIndex + 1, " / ").concat(images.length);
    }
    function openLightbox(index) {
        currentIndex = index;
        updateImage();
        lightbox.removeAttribute("hidden");
        document.body.style.overflow = "hidden";
        previouslyFocused = document.activeElement;
        requestAnimationFrame(function() {
            return lightboxClose && lightboxClose.focus();
        });
    }
    function closeLightbox() {
        lightbox.setAttribute("hidden", "");
        document.body.style.overflow = "";
        previouslyFocused && previouslyFocused.focus();
    }
    // Attach click handlers to trigger buttons
    slides.forEach(function(slide, idx) {
        var trigger = slide.querySelector(".practice-lightbox-trigger");
        if (trigger) trigger.addEventListener("click", function() {
            return openLightbox(idx);
        });
    });
    lightboxClose && lightboxClose.addEventListener("click", closeLightbox);
    lightboxBackdrop && lightboxBackdrop.addEventListener("click", closeLightbox);
    lightboxPrev && lightboxPrev.addEventListener("click", function() {
        if (currentIndex > 0) {
            currentIndex--;
            updateImage();
        }
    });
    lightboxNext && lightboxNext.addEventListener("click", function() {
        if (currentIndex < images.length - 1) {
            currentIndex++;
            updateImage();
        }
    });
    // Keyboard: Escape and arrow navigation
    document.addEventListener("keydown", function(e) {
        if (lightbox.hasAttribute("hidden")) return;
        if (e.key === "Escape") {
            closeLightbox();
            return;
        }
        if (e.key === "ArrowLeft" && currentIndex > 0) {
            currentIndex--;
            updateImage();
        }
        if (e.key === "ArrowRight" && currentIndex < images.length - 1) {
            currentIndex++;
            updateImage();
        }
    });
    // Focus trap
    lightbox.addEventListener("keydown", function(e) {
        if (e.key !== "Tab") return;
        var focusable = Array.from(lightbox.querySelectorAll("button")).filter(function(el) {
            return !el.hasAttribute("disabled") && el.getAttribute("aria-disabled") !== "true";
        });
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    });
}

},{"7fe80a3a61d1c5c5":"g5hRe"}],"g5hRe":[function(require,module,exports,__globalThis) {
module.exports = require("e338c5ff9ad64481")(module.bundle.resolve("eQCjh")).then(function() {
    return module.bundle.root('bp4wN');
});

},{"e338c5ff9ad64481":"1MWbm"}],"1MWbm":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"4yBbG"}],"4yBbG":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}]},["axXgE","lqvwy"], "lqvwy", "parcelRequired6e5", {}, "../../../../", "/")

//# sourceMappingURL=content-single-practice.js.map
